import { Extension } from "@tiptap/core"

export const defaultUiState = {
  aiGenerationIsSelection: false,
  aiGenerationIsLoading: false,
  aiGenerationActive: false,
  aiGenerationHasMessage: false,
  commentInputVisible: false,
  lockDragHandle: false,
  isDragging: false
}

export const UiState = Extension.create({
  name: "uiState",

  addStorage() {
    return {
      uiState: { ...defaultUiState },
    }
  },

  addCommands() {
    const createBooleanSetter =
      (key) => (value) => () => {
        this.storage[key] = value
        return true
      }

    const createToggle = (key, value) => () => () => {
      this.storage[key] = value
      return true
    }

    return {
      // AI Generation commands
      aiGenerationSetIsSelection: createBooleanSetter("aiGenerationIsSelection"),
      aiGenerationSetIsLoading: createBooleanSetter("aiGenerationIsLoading"),
      aiGenerationHasMessage: createBooleanSetter("aiGenerationHasMessage"),
      aiGenerationShow: createToggle("aiGenerationActive", true),
      aiGenerationHide: createToggle("aiGenerationActive", false),

      // Comment input commands
      commentInputShow: createToggle("commentInputVisible", true),
      commentInputHide: createToggle("commentInputVisible", false),

      // Drag handle commands
      setLockDragHandle: createBooleanSetter("lockDragHandle"),
      setIsDragging: createBooleanSetter("isDragging"),

      // Reset command
      resetUiState: () => () => {
        Object.assign(this.storage, { ...defaultUiState })
        return true
      },
    };
  },

  onCreate() {
    this.storage = { ...defaultUiState }
  },
})
